var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3809 3.92236C14.454 2.84767 16.1947 2.84668 17.2686 3.9204L19.7608 6.41259C20.8252 7.47732 20.8359 9.20051 19.7852 10.2788L10.5518 19.7524C9.84631 20.4762 8.87859 20.8843 7.86823 20.8843H5.11627C3.83739 20.884 2.81664 19.8183 2.87018 18.5395L2.98737 15.73C3.02696 14.7911 3.4174 13.9006 4.08112 13.2358L13.3809 3.92236ZM5.14166 14.2964C4.74339 14.6953 4.50911 15.23 4.48541 15.7935L4.36725 18.602C4.34933 19.0283 4.69006 19.384 5.11627 19.3843H7.8692C8.47529 19.3842 9.05634 19.1388 9.47955 18.7046L16.0108 12.0015L11.7178 7.70947L5.14166 14.2964ZM16.209 4.98193C15.7209 4.49381 14.9292 4.49439 14.4415 4.9829L12.7774 6.64794L17.0577 10.9272L18.711 9.23193C19.1886 8.74186 19.1849 7.95813 18.7012 7.47412L16.209 4.98193Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3819 19.311C20.7959 19.311 21.1318 19.6467 21.1319 20.061C21.1319 20.4754 20.796 20.811 20.3819 20.811H14.2608C13.8467 20.811 13.5108 20.4754 13.5108 20.061C13.5109 19.6467 13.8468 19.311 14.2608 19.311H20.3819Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.bf5dafa9a0f2057045c3a1c5e69048ea.svg";
export { ForwardRef as ReactComponent };